import { BasicLogFormat } from './basic-log-format';
const { v4: uuidv4 } = require('uuid');
export class CloudwatchLogFormat extends BasicLogFormat {
    constructor() {
        super(...arguments);
        this.label = uuidv4();
        this.transform = (item) => {
            const { message } = item;
            let formattedMessage = message;
            if (!process.env.CLOUDWATCH_LOGS_STREAM_PER_THREAD) {
                formattedMessage = `${this.label} ${message}`;
            }
            item.message = formattedMessage;
            return item;
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xvdWR3YXRjaC1sb2ctZm9ybWF0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9jbG91ZHdhdGNoLWxvZy1mb3JtYXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBRXZELE1BQU0sRUFBRSxFQUFFLEVBQUUsTUFBTSxFQUFFLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0FBRXZDLE1BQU0sT0FBTyxtQkFBb0IsU0FBUSxjQUFjO0lBQXZEOztRQUNFLFVBQUssR0FBRyxNQUFNLEVBQUUsQ0FBQztRQUNqQixjQUFTLEdBQUcsQ0FBQyxJQUF1QixFQUFFLEVBQUU7WUFDdEMsTUFBTSxFQUFFLE9BQU8sRUFBRSxHQUFHLElBQUksQ0FBQztZQUN6QixJQUFJLGdCQUFnQixHQUFHLE9BQU8sQ0FBQztZQUMvQixJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxpQ0FBaUMsRUFBRTtnQkFDbEQsZ0JBQWdCLEdBQUcsR0FBRyxJQUFJLENBQUMsS0FBSyxJQUFJLE9BQU8sRUFBRSxDQUFDO2FBQy9DO1lBRUQsSUFBSSxDQUFDLE9BQU8sR0FBRyxnQkFBZ0IsQ0FBQztZQUNoQyxPQUFPLElBQUksQ0FBQztRQUNkLENBQUMsQ0FBQztJQUNKLENBQUM7Q0FBQSJ9